/*
 *
 *  remotes
 *
 */


import api from "../../helpers/Api"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export function loadEcFollowupDetails(id) {
  let payload = { status: "both", leadId: id }

  return api
    .post(`/list_Ec_followup`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//
//loadReview
export function loadReviewDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/list_followup_reviews`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//Instructions API list
/**
 *
 * @param {integer} id
 * @returns
 */

export function loadOperationsFollowupDetails(id) {
  let payload = { leadId: id }

  return api
    .post(`/list_deliverable_followup`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function addOperationsFollowupDetails(ecFollowupData) {

  try {
    const response = await api.post(
      `/add_deliverable_followup`,
      ecFollowupData
    )
    console.log(response.data, "response data from api call")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateOperationsFollowupDetails(ecFollowupData) {
  try {
    const response = await api.post(
      `/update_deliverable_followup`,
      ecFollowupData
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}


export function loadCheckListApi(id) {
  let payload = { leadId: id, status: "active" }

  return api
    .post(`/get_all_event_check_list_question`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


export function loadTeamScheduleApi(id) {
  let payload = { leadId: id, status: "active" }

  return api
    .post(`/get_all_event_team_schedule`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


export function loadEcAppApi(id) {
  let payload = { leadId: id }

  return api
    .post(`/ec_app_event_logs`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadEcEventApi(id) {
  return api
    .post(`/ec_app_event_details`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadDeliverablesAPi(id) {
  return api
    .post(`/deliverable_details`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function loadDeliverableStatusApi(id) {
  return api
    .post(`/list_deliverable_status_section`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


 export function loadIssuesApi(id) {
  return api
    .post(`/list_issues`, id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadCallCriteriaApi(id) {
  return api
    .post(`/getAllCallCriteria`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadcallActionsApi(id) {
  return api
    .post(`/getAllCallCriteria`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadDeliverableTagApi(id) {
  return api
    .post(`/getAllDeliverableTag`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function addIssuesDetails(id) {
  return api
    .post(`/add_issues`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function updateIssuesDetails(id) {
  return api
    .post(`/update_issues`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function deleteIssuesDetails(id) {
  return api
    .post(`/delete_issues`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function loadcallRecordingApi(id) {
  return api
    .post(`/sales_and_ec_attachment_data`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export function updateNotesApi(id) {
  return api
    .post(`/update_lead_crm_notes`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function updateReviewApi(id) {
  return api
    .post(`/update_followup_reviews`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export function addReviewApi(id) {
  return api
    .post(`/add_followup_reviews`,id)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadRecordsMetaData,
  loadEcFollowupDetails,
  loadOperationsFollowupDetails,
  addOperationsFollowupDetails,
  updateOperationsFollowupDetails,
  loadCheckListApi,
  loadTeamScheduleApi,
  loadEcAppApi,
  loadEcEventApi,
  loadDeliverablesAPi,
  loadDeliverableStatusApi,
  loadIssuesApi,
  loadcallActionsApi,
  loadCallCriteriaApi,
  loadDeliverableTagApi,
  addIssuesDetails,
  updateIssuesDetails,
  deleteIssuesDetails,
  loadcallRecordingApi,
  updateNotesApi,
  loadReviewDetails,
  addReviewApi,
  updateReviewApi

}

export default remotes
